// Small DOM helpers for the debug overlay. No framework; just enough to keep
// the calibration and perch panels readable.

export function el(tag, props = {}, children = []) {
  const node = document.createElement(tag);
  for (const [k, v] of Object.entries(props)) {
    if (k === 'class') node.className = v;
    else if (k === 'text') node.textContent = v;
    else if (k.startsWith('on')) node.addEventListener(k.slice(2).toLowerCase(), v);
    else node.setAttribute(k, v);
  }
  for (const c of children) node.append(c);
  return node;
}

export function button(label, onClick, props = {}) {
  return el('button', { type: 'button', text: label, onClick, ...props });
}

export function select(options, value, onChange) {
  const node = el('select', { onChange: (e) => onChange(e.target.value) });
  for (const opt of options) {
    const [val, label] = Array.isArray(opt) ? opt : [opt, String(opt)];
    node.append(el('option', { value: val, text: label }));
  }
  node.value = String(value);
  return node;
}

/**
 * Slider with minus/plus nudge buttons. `step` is a function so coarse/fine
 * can be switched globally without rebuilding the control.
 */
export function slider({ label, min, max, step, value, decimals = 3, onChange }) {
  let current = value;
  const lab = el('span', { class: 'lab', text: label });
  const val = el('span', { class: 'val' });
  const range = el('input', { type: 'range', min, max, step: step() });
  const show = () => {
    val.textContent = Number(current).toFixed(decimals);
    range.value = String(current);
  };
  const set = (next, notify = true) => {
    current = Math.min(max, Math.max(min, next));
    show();
    if (notify) onChange(current);
  };
  range.addEventListener('input', () => set(parseFloat(range.value)));
  const minus = button('-', () => set(current - step()));
  const plus = button('+', () => set(current + step()));
  const root = el('div', { class: 'mw-slider' }, [lab, val, el('div', { class: 'ctl' }, [minus, range, plus])]);
  show();
  return {
    root,
    get value() {
      return current;
    },
    set: (v) => set(v, false),
    refreshStep: () => {
      range.step = String(step());
    },
  };
}
